import type { ComponentChildren } from "preact";

export type BadgeTone = "neutral" | "success" | "danger" | "warning" | "info" | "violet" | "muted";

export function Badge({ tone = "neutral", dot = false, children }: { tone?: BadgeTone; dot?: boolean; children: ComponentChildren }) {
  return (
    <span class={`badge badge--${tone}`}>
      {dot && <span class="badge__dot" style={{ background: "currentColor" }} />}
      {children}
    </span>
  );
}

const STAGE_TONE: Record<string, BadgeTone> = {
  "New Lead": "neutral",
  Qualified: "info",
  "Proposal Sent": "violet",
  Negotiation: "warning",
  Won: "success",
  Lost: "danger",
};

export function StageBadge({ stage }: { stage: string }) {
  return (
    <Badge tone={STAGE_TONE[stage] ?? "neutral"} dot>
      {stage}
    </Badge>
  );
}

const COMPANY_STATUS_TONE: Record<string, BadgeTone> = {
  Prospect: "info",
  "Active Customer": "success",
  "At Risk": "warning",
  Churned: "muted",
};

export function CompanyStatusBadge({ status }: { status: string }) {
  return (
    <Badge tone={COMPANY_STATUS_TONE[status] ?? "neutral"} dot>
      {status}
    </Badge>
  );
}

const PROPOSAL_TONE: Record<string, BadgeTone> = {
  Draft: "muted",
  Sent: "info",
  Viewed: "info",
  Accepted: "success",
  Rejected: "danger",
  Expired: "danger",
};

export function ProposalStatusBadge({ status }: { status: string }) {
  return <Badge tone={PROPOSAL_TONE[status] ?? "neutral"}>{status}</Badge>;
}

const INVOICE_TONE: Record<string, BadgeTone> = {
  Draft: "muted",
  Sent: "info",
  "Partially Paid": "violet",
  Paid: "success",
  Overdue: "danger",
  Void: "neutral",
};

export function InvoiceStatusBadge({ status }: { status: string }) {
  return (
    <Badge tone={INVOICE_TONE[status] ?? "neutral"} dot>
      {status}
    </Badge>
  );
}

const PRIORITY_TONE: Record<string, BadgeTone> = {
  Low: "muted",
  Medium: "info",
  High: "warning",
};

export function PriorityBadge({ priority }: { priority: string }) {
  return (
    <Badge tone={PRIORITY_TONE[priority] ?? "neutral"} dot>
      {priority}
    </Badge>
  );
}
